import { render, staticRenderFns } from "./CoreTechMod.vue?vue&type=template&id=5b0df4c6&scoped=true"
import script from "./CoreTechMod.vue?vue&type=script&lang=js"
export * from "./CoreTechMod.vue?vue&type=script&lang=js"
import style0 from "./CoreTechMod.vue?vue&type=style&index=0&id=5b0df4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0df4c6",
  null
  
)

export default component.exports